import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearIndeterminate({ visible }) {
    return (
        visible ?
            <Box sx={{ width: '100%' }} >
                <LinearProgress color="primary" />
            </Box> :
            <Box sx={{ height: "4px", width: "100%" }} />
    );
}
